/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_EyebrowInputs */

const en_us2_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For suggestions that fit you`)
};

const pt_br2_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sugestões sob medida`)
};

const es_419_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sugerencias a tu medida`)
};

const pt_pt2_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sugestões à tua medida`)
};

const fr_fr2_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour des suggestions sur mesure`)
};

const de_de2_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Vorschläge, die zu dir passen`)
};

const it_it2_plan_build_grounding_eyebrow = /** @type {(inputs: Plan_Build_Grounding_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per suggerimenti su misura`)
};

/**
* | output |
* | --- |
* | "For suggestions that fit you" |
*
* @param {Plan_Build_Grounding_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_eyebrow = /** @type {((inputs?: Plan_Build_Grounding_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_eyebrow(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_eyebrow(inputs)
	return en_us2_plan_build_grounding_eyebrow(inputs)
});
export { plan_build_grounding_eyebrow as "plan-build.grounding_eyebrow" }